import { Injectable } from '@angular/core';
import { BaseService } from './base/base.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MaskedEmail } from '../../model/masked-email';
import { RegisterAccount } from "../../model/register-account";
import { NumberModel } from "../../model/user/number.model";
import { SendOtpResult } from "../../model/send-otp-result";
import { CreateShoppingCreditSessionResponse } from "../../model/create.shopping.credit.session";
import { UpdateOrderForCreditProvider } from "../../model/update.order.for.credit.provider";


@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService {
  resourceUrl = 'user';

  //Email doğrulaması olup olmadığını kontrol eden servis.
  isThereMailVerification(trackingId: string): Observable<boolean> {
    return this.get(`is-there-mail-verification/${trackingId}`);
  }

  //Sözlesme flaglerini set eden servis.
  setAccountFlags(trackingId: string): Observable<any> {
    return this.get(`set-account-flags/${trackingId}`);
  }

  //Yeni kullanıcı kayıt eden servis.
  signup(registerAccount: RegisterAccount, trackingId: string): Observable<any> {
    return this.post(`register-account/${trackingId}`, registerAccount);
  }

  //Yeni şifre belirleyen servis.
  createPin(numberModel: NumberModel, trackingId: string): Observable<any> {
    return this.post(`create-pin/${trackingId}`, numberModel);
  }

  //Email bilgisini maskeli getiren servis.
  getMaskedEmail(trackingId: string): Observable<MaskedEmail> {
    return this.get(`email/${trackingId}`);
  }

  //Şifre yenileme e-postası gönderen servis.
  sendRecoveryEmail(trackingId: string): Observable<any> {
    return this.get(`recovery/send/${trackingId}`);
  }

  //E posta doğrulama linki gönderen servis.
  sendEmailValidation(trackingId: string): Observable<any> {
    return this.get(`send-email-validation/${trackingId}`);
  }

  updateAccountInfoMg(trackingId: string, message: string) {
    return this.get(`update-account-info/${trackingId}` + '?key=' + message);
  }

  createShoppingCreditSession(trackingId: string) : Observable<CreateShoppingCreditSessionResponse> {
    return this.get(`create-shopping-credit-session/${trackingId}`);
  }

  updateOrderForCreditProvider(trackingId: string, updateOrderCreditProvider: UpdateOrderForCreditProvider): Observable<boolean> {
    return this.post(`update-order-for-credit-provider/${trackingId}`, updateOrderCreditProvider);
  }

  getHttpParams(): HttpParams {
    return undefined;
  }

  getPath(): string {
    return this.resourceUrl;
  }

}
